import React from "react";
import { Button } from "@material-ui/core";

import * as Constants from "../../../../constants/Constants";
import "./ViewModiyRenderer.css";

const ViewModiyRenderer = (props) => {
  const { emailTemplateEditHandler, data } = props;
  return (
    <>
      <Button
        id="viewModifyButton"
        className="button-primary-md viewModifyButton"
        onClick={() => emailTemplateEditHandler(data)}
      >
        {Constants.VIEW_MODIFY}
      </Button>
    </>
  );
};

export default ViewModiyRenderer;
